import type { SupportedLocale } from '../types'

const LOCALE_TO_COUNTRY: Record<SupportedLocale, string> = {
  en: 'GB', // United Kingdom (more common than US for international forms)
  sv: 'SE', // Sweden
  es: 'ES', // Spain
  de: 'DE', // Germany
  fr: 'FR', // France
  nl: 'NL', // Netherlands
  fi: 'FI', // Finland
  no: 'NO', // Norway
  da: 'DK', // Denmark
  pl: 'PL', // Poland
}

export function getDefaultCountryForLocale(locale: SupportedLocale): string {
  return LOCALE_TO_COUNTRY[locale] || 'GB'
}
